import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  paymentMethodContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  paymentMethodLabel: {
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
  },
  paymentMethodOptions: {
    gap: theme.spacing(2),
    '@media (max-width: 640px)': {
      flexDirection: 'column',
    },
  },
  paymentMethodOption: {
    border: `1px solid ${theme.evPalette.charcoal[300]}`,
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1.5)}px`,
    width: 'fit-content',
    '& .myev-MuiCheckbox-root': {
      padding: theme.spacing(0.5),
    },
  },
  paymentMethodOptionSelected: {
    borderColor: theme.evPalette.ocean[600],
    backgroundColor: theme.evPalette.ocean[50],
  },
  panelHeader: {
    display: 'flex',
    whiteSpace: 'nowrap',
  },
  secondaryHeader: {
    fontWeight: 400,
    color: theme.evPalette.charcoal[800],
    fontSize: '14px',
    '@media (min-width: 640px)': {
      marginLeft: theme.spacing(1),
    },
  },
  cardImage: {
    '@media (min-width: 640px)': {
      marginLeft: theme.spacing(1),
    },
  },
  accountBalance: {
    fontWeight: 600,
  },
  planType: {
    paddingBottom: theme.spacing(2),
  },
  paymentOption: {
    fontWeight: 600,
    fontSize: theme.spacing(1.5),
  },
}));
